import {Text, TextAppearance, TextTag} from '@ngw6/us-components';
import React from 'react';
import {SpinnerIcon} from '../../components/icons/spinner-icon';
import {StyledLoaderWrapper, TextWrapper} from './styled';

interface LoaderSpinnerProps {
  readonly label?: string;
}

export const LoaderSpinner: React.FC<LoaderSpinnerProps> = (
  props,
): JSX.Element => {
  const {label} = props;

  return (
    <StyledLoaderWrapper>
      <SpinnerIcon iconSize={36} />
      <TextWrapper>
        <Text appearance={TextAppearance.copy200} tag={TextTag.span}>
          {!label ? label : 'Loading...'}
        </Text>
      </TextWrapper>
    </StyledLoaderWrapper>
  );
};
